import React, { useEffect, useState, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import {
  getAccountCurrency,
  displayDecimalFormatted,
} from "../../../../../utils/systemSettings";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../../../utils/useNavigation";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../../../store/actions";
import { apiCall } from "../../../../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../../../../store/services/URL";
import clientService from "../../../../../store/services/clients.service";
import CustomInput from "../../../input/customInput/CustomInput";
import CustomSelect from "../../../select/CustomSelect";
import {
  createBudgetRequest,
  updateBudgetRequest,
} from "../../../../../store/actions/budgets.actions";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const BudgetRow = (props) => {
  const {
    data,
    sortingCriteria,
    handleModal,
    menu,
    parentType,
    projectId,
    programId,
    portfolioId,
    sortBudgetRequest,
    updateFlag,
    columnConfig,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [setting] = useState(settings);
  const popoverRef = useRef(null);
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const [clients, setClients] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [isEditRecord, setIsEditRecord] = useState(null);
  const [formErrors, setFormErrors] = useState({
    scopeName: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
    completion: "",
    projectId: "",
  });
  const dispatch = useDispatch();
  const nameInputRef = useRef(null);
  const codeInputRef = useRef(null);
  const initialBudgetCostInputRef = useRef(null);
  const changeRequestsCostInputRef = useRef(null);
  const revisedBudgetCostInputRef = useRef(null);
  const actualInputRef = useRef(null);
  const pvInputRef = useRef(null);
  const evInputRef = useRef(null);
  const etcInputRef = useRef(null);
  const bacInputRef = useRef(null);

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data.client) {
      data.clientId = data.client.id;
    } else {
      delete data.client;
    }
    if (data.portfolio) {
      data.portfolioId = data.portfolio.id;
    }
    {
      delete data.portfolio;
    }
    if (data.program) {
      data.programId = data.program.id;
    }
    {
      delete data.program;
    }
    if (data.project) {
      data.projectId = data.project.id;
    }
    if (data.changeRequest) {
      data.changeRequestId = data.changeRequest.id;
    }
    delete data.owner;
    delete data.isFlagged;
    delete data.dateCreated;
    if (parentType === "Project") {
      data.projectId = projectId;
    } else if (parentType === "Program") {
      data.programId = programId;
    } else if (parentType === "Portfolio") {
      data.portfolioId = portfolioId;
    }

    if (data.name && data.projectId) {
      if (data.id) {
        if (parentType === "Project") {
          dispatch(
            updateBudgetRequest({
              id: data.id,
              parentID: projectId,
              parent: "Project",
              payload: data,
            })
          );
          setIsEditRecord(null);
          return;
        }
        if (parentType === "Program") {
          dispatch(
            updateBudgetRequest({
              id: data.id,
              parentID: programId,
              parent: "Program",
              payload: data,
            })
          );
          setIsEditRecord(null);
          return;
        }
        if (parentType === "Portfolio") {
          dispatch(
            updateBudgetRequest({
              id: data.id,
              parentID: portfolioId,
              parent: "Portfolio",
              payload: data,
            })
          );
          setIsEditRecord(null);
          return;
        }

        dispatch(
          updateBudgetRequest({
            id: data.id,
            parentID: data.id,
            parent: "Budget",
            payload: data,
          })
        );
        setIsEditRecord(null);
      } else {
        if (parentType === "Project") {
          dispatch(
            createBudgetRequest({
              parentID: projectId,
              parent: "Project",
              payload: { ...data },
            })
          );
          setIsEditRecord(null);
          return;
        }
        if (parentType === "Program") {
          dispatch(
            createBudgetRequest({
              parentID: programId,
              parent: "Program",
              payload: data,
            })
          );
          setIsEditRecord(null);
          return;
        }
        if (parentType === "Portfolio") {
          dispatch(
            createBudgetRequest({
              parentID: portfolioId,
              parent: "Portfolio",
              payload: data,
            })
          );
          setIsEditRecord(null);
          return;
        }

        dispatch(createBudgetRequest({ parent: "Budget", payload: data }));
        setIsEditRecord(null);
      }
    } else {
      const errors = {};
      if (!data.name) errors["name"] = `The Name field is required.`;
      if (!data.project) errors["projectId"] = `The Project field is required.`;
      setFormErrors(errors);
      if (!data.name) {
        return dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      } else if (!data.project) {
        return dispatch(
          generalActions.showToast({
            title: "Project is a required field",
            type: "error",
          })
        );
      }
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      const payload = {
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      };
      if (parentType === "Budget") payload.parent = "Budget";
      if (parentType === "Project") {
        payload.id = projectId;
        payload.parent = "Project";
      }
      if (parentType === "Program") {
        payload.id = programId;
        payload.parent = "Program";
      }
      if (parentType === "Portfolio") {
        payload.id = portfolioId;
        payload.parent = "Portfolio";
      }
      sortBudgetRequest(payload);
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempDate = [...data];
      tempDate.push({
        name: "",
        client: null,
        portfolio: null,
        program: null,
        project: null,
        bac: 0,
        etc: 0,
        pv: 0,
        ev: 0,
        actual: 0,
        revisedBudgetCost: 0,
        initialBudgetCost: 0,
        changeRequestsCost: 0,
        code: "",
      });
      setSortedData(tempDate);
    }
  }, [data]);

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "div" &&
      event.target.className && // Ensure className exists
      typeof event.target.className === "string" && // Ensure className is a string
      !event.target.className.includes("fui-Dropdown__button")
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);

  const handleInputChange = (value, type) => {
    let error = { ...formErrors };
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      error["name"] = ``;
      setFormErrors(error);
      data.name.name = value;
      setIsEditRecord(data);
    } else if (type === "project") {
      error["projectId"] = ``;
      setFormErrors(error);
      if (!value) {
        data.name.project = null;
      } else {
        if (!data.name?.project) {
          data.name.project = {};
        }
        data.name.project.name = value.label;
        data.name.project.id = value.value;
      }
      setIsEditRecord(data);
    } else if (type === "client") {
      if (!value) {
        data.name.client = null;
      } else {
        if (!data.name?.client) {
          data.name.client = {};
        }
        data.name.client.name = value.label;
        data.name.client.id = value.value;
      }
      data.name.project = null;
      data.name.portfolio = null;
      data.name.program = null;
      setIsEditRecord(data);
    } else if (type === "portfolio") {
      if (!value) {
        data.name.portfolio = null;
      } else {
        if (!data.name?.portfolio) {
          data.name.portfolio = {};
        }
        data.name.portfolio.name = value.label;
        data.name.portfolio.id = value.value;
      }
      data.name.program = null;
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "program") {
      if (!value) {
        data.name.program = null;
      } else {
        if (!data.name?.program) {
          data.name.program = {};
        }
        data.name.program.name = value.label;
        data.name.program.id = value.value;
      }
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "bac") {
      data.name.bac = value;
      setIsEditRecord(data);
    } else if (type === "etc") {
      data.name.etc = value;
      setIsEditRecord(data);
    } else if (type === "ev") {
      data.name.ev = value;
      setIsEditRecord(data);
    } else if (type === "pv") {
      data.name.pv = value;
      setIsEditRecord(data);
    } else if (type === "actual") {
      data.name.actual = value;
      setIsEditRecord(data);
    } else if (type === "revisedBudgetCost") {
      data.name.revisedBudgetCost = value;
      setIsEditRecord(data);
    } else if (type === "changeRequestsCost") {
      data.name.changeRequestsCost = value;
      setIsEditRecord(data);
    } else if (type === "initialBudgetCost") {
      data.name.initialBudgetCost = value;
      setIsEditRecord(data);
    } else if (type === "code") {
      data.name.code = value;
      setIsEditRecord(data);
    }
  };

  const focusField = (type) => {
    switch (type) {
      case "name":
        nameInputRef?.current.focus();
        break;
      case "bac":
        bacInputRef?.current?.focus();
        break;
      case "etc":
        etcInputRef?.current?.focus();
        break;
      case "ev":
        evInputRef?.current?.focus();
        break;
      case "pv":
        pvInputRef?.current?.focus();
        break;
      case "actual":
        actualInputRef?.current?.focus();
        break;
      case "revisedBudgetCost":
        revisedBudgetCostInputRef?.current?.focus();
        break;
      case "changeRequestsCost":
        changeRequestsCostInputRef?.current?.focus();
        break;
      case "initialBudgetCost":
        initialBudgetCostInputRef?.current?.focus();
        break;
      case "code":
        codeInputRef?.current?.focus();
        break;
      default:
        break;
    }
  };

  const handleIsEdiRecord = (index, type) => {
    if (index === data.length && type !== "name") {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }

    setIsEditRecord({ index: index, name: { ...sortedData[index] } });

    setTimeout(() => {
      focusField(type);
    }, 0);
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Budget";

    if (isEditRecord?.name?.client) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.program) {
      queryParam = `?programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.portfolio) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&portfolioId=${isEditRecord?.name?.portfolio?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.program) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio && isEditRecord?.name?.program) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (
      isEditRecord?.name?.client &&
      isEditRecord?.name?.portfolio &&
      isEditRecord?.name?.program
    ) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&portfolioId=${isEditRecord?.name?.portfolio?.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (parentType === "Program") {
      queryParam = queryParam + `&programId=${programId}`;
    } else if (parentType === "Portfolio") {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setPrograms([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Project";

    if (isEditRecord?.name?.client) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.portfolio) {
      queryParam = `?clientId=${isEditRecord?.name?.client.id}&portfolioId=${isEditRecord?.name?.portfolio.id}&searchTerm=${payload.searchText}`;
    }

    if (parentType === "Portfolio") {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPrograms(transformedArray);
      })
      .catch(() => {
        setPrograms([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: isEditRecord?.name?.client?.id, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (isEditRecord?.name?.client)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  const handleRedirectClient = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      navigateTo("Clients", item.client.id, item.client.name);
    }
  };

  const handleRedirectPortfolio = (item) => {
    if (item.portfolio) {
      if (parentType !== "Portfolio") {
        // Use navigation hook for direct navigation to portfolio
        navigateTo("Portfolios", item.portfolio.id, item.portfolio.name);
      } else {
        // Already in portfolio context, just navigate
        navigateTo("Portfolios", item.portfolio.id, item.portfolio.name);
      }
    }
  };

  const handleRedirectProgram = (item) => {
    if (item.program) {
      if (parentType !== "Program") {
        // Use navigation hook for direct navigation to program
        navigateTo("Programs", item.program.id, item.program.name);
      } else {
        // Already in program context, just navigate
        navigateTo("Programs", item.program.id, item.program.name);
      }
    }
  };

  const handleRedirectProject = (item) => {
    if (item.project) {
      // Use navigation hook for direct navigation to project
      navigateTo("Projects", item.project.id, item.project.name);
    }
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempDate = [...sortedArray];
    tempDate.push({
      name: "",
      client: null,
      portfolio: null,
      program: null,
      project: null,
      bac: 0,
      etc: 0,
      pv: 0,
      ev: 0,
      actual: 0,
      revisedBudgetCost: 0,
      initialBudgetCost: 0,
      changeRequestsCost: 0,
      code: "",
    });
    setSortedData(tempDate);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Description":
        return (
          <TableCell>
            <div className="d-flex justify-content-between inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder="Add description"
                    value={isEditRecord.name.name}
                    type="text"
                    handleChange={(value) => handleInputChange(value, "name")}
                    ref={nameInputRef}
                    errorMessage={formErrors.name}
                    displayErrorMessage={false}
                  />
                ) : item?.id ? (
                  <span
                    className="d-flex w-full text-truncate"
                    onClick={() => handleIsEdiRecord(index, "name")}
                  >
                    {item.name}
                  </span>
                ) : (
                  <div
                    className="d-flex _add_btn"
                    onClick={() =>
                      handleIsEdiRecord(sortedData.length - 1, "name")
                    }
                  >
                    <PlusIcon />
                    Add
                  </div>
                )}
              </div>
              {item?.id && (
                <div className={`flag`}>
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Client":
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              SelectText="client"
              searchText={searchClientHandler}
              options={clients}
              defaultVal={
                isEditRecord.name.client
                  ? {
                      label: isEditRecord.name.client.name,
                      value: isEditRecord.name.client.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "client")}
              CustomClass="ModalAvatarSearch"
            />
          </TableCell>
        ) : (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "client")}
          >
            <span onClick={() => handleRedirectClient(item)}>
              {item.client?.name}
            </span>
          </TableCell>
        );
      case "Portfolio":
        if (parentType === "Portfolio") return null;
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              CustomClass="ModalAvatarSearch"
              persona={true}
              searchText={searchPortfolioHandler}
              SelectText="portfolio"
              options={portfolioOptions}
              defaultVal={
                isEditRecord.name.portfolio?.name
                  ? {
                      label: isEditRecord.name.portfolio.name,
                      value: isEditRecord.name.portfolio.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "portfolio")}
            />
          </TableCell>
        ) : (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "portfolio")}
          >
            <span onClick={() => handleRedirectPortfolio(item)}>
              {item.portfolio?.name}
            </span>
          </TableCell>
        );
      case "Program":
        if (parentType === "Program") return null;
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              SelectText="program"
              searchText={searchProgramHandler}
              options={programs}
              defaultVal={
                isEditRecord.name.program?.name
                  ? {
                      label: isEditRecord.name.program.name,
                      value: isEditRecord.name.program.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "program")}
              CustomClass="ModalAvatarSearch"
            />
          </TableCell>
        ) : (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "program")}
          >
            <span onClick={() => handleRedirectProgram(item)}>
              {item.program?.name}
            </span>
          </TableCell>
        );
      case "Project":
        if (parentType === "Project") return null;
        return isEditing ? (
          <TableCell>
            <CustomSelect
              SelectText="project"
              searchText={searchProjectHandler}
              options={projectOptions}
              defaultVal={
                isEditRecord.name.project?.name
                  ? {
                      label: isEditRecord.name.project.name,
                      value: isEditRecord.name.project.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "project")}
              CustomClass="ModalAvatarSearch"
              errorMessage={formErrors.projectId}
              displayErrorMessage={false}
            />
          </TableCell>
        ) : (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "project")}
          >
            <span onClick={() => handleRedirectProject(item)}>
              {item.project?.name}
            </span>
          </TableCell>
        );
      case "Claim Code":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "code")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.code}
                placeholder="Add Claim code"
                type="text"
                handleChange={(value) => handleInputChange(value, "code")}
                ref={codeInputRef}
              />
            ) : (
              item.code
            )}
          </TableCell>
        );
      case "Initial Budget":
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "initialBudgetCost")}
          >
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.initialBudgetCost}
                type="number"
                currency={true}
                inline={true}
                placeholder="0"
                handleChange={(value) =>
                  handleInputChange(value, "initialBudgetCost")
                }
                ref={initialBudgetCostInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.initialBudgetCost
              )}`
            )}
          </TableCell>
        );
      case "Change Request":
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "changeRequestsCost")}
          >
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.changeRequestsCost}
                type="number"
                currency={true}
                inline={true}
                placeholder="0"
                handleChange={(value) =>
                  handleInputChange(value, "changeRequestsCost")
                }
                ref={changeRequestsCostInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.changeRequestsCost
              )}`
            )}
          </TableCell>
        );
      case "Revised Budget":
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "revisedBudgetCost")}
          >
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.revisedBudgetCost}
                type="number"
                currency={true}
                inline={true}
                placeholder="0"
                handleChange={(value) =>
                  handleInputChange(value, "revisedBudgetCost")
                }
                ref={revisedBudgetCostInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.revisedBudgetCost
              )}`
            )}
          </TableCell>
        );
      case "Actual":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "actual")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.actual}
                type="number"
                currency={true}
                inline={true}
                placeholder="0"
                handleChange={(value) => handleInputChange(value, "actual")}
                ref={actualInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.actual
              )}`
            )}
          </TableCell>
        );
      case "PV":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "pv")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.pv}
                type="number"
                currency={true}
                inline={true}
                placeholder="0"
                handleChange={(value) => handleInputChange(value, "pv")}
                ref={pvInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.pv
              )}`
            )}
          </TableCell>
        );
      case "EV":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "ev")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.ev}
                type="number"
                currency={true}
                inline={true}
                placeholder="0"
                handleChange={(value) => handleInputChange(value, "ev")}
                ref={evInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.ev
              )}`
            )}
          </TableCell>
        );
      case "ETC":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "etc")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.etc}
                type="number"
                currency={true}
                inline={true}
                placeholder="0"
                handleChange={(value) => handleInputChange(value, "etc")}
                ref={etcInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.etc
              )}`
            )}
          </TableCell>
        );
      case "BAC":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "bac")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.bac}
                type="number"
                currency={true}
                inline={true}
                placeholder="0"
                handleChange={(value) => handleInputChange(value, "bac")}
                ref={bacInputRef}
              />
            ) : (
              item?.id &&
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.bac
              )}`
            )}
          </TableCell>
        );
      case "CV":
        return (
          <TableCell className="BlueFieldBg">
            {item?.id
              ? `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  item.cv
                )}`
              : ""}
          </TableCell>
        );
      case "SV":
        return (
          <TableCell className="BlueFieldBg">
            {item?.id
              ? `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  item.sv
                )}`
              : ""}
          </TableCell>
        );
      default:
        return null;
    }
  };

  const styles = useStyles();
  return (
    <>
      {sortedData.map((item, index) => (
        <TableRow key={item.id || index} ref={popoverRef}>
          {sortedColumnConfig
            .filter((col) => col.isVisible)
            .map((col) => renderTableCell(item, index, col))}
        </TableRow>
      ))}
    </>
  );
};

export default BudgetRow;
